import {connect} from "react-redux";

import Form from "../../../../components/Chat/ChatBot/Form/Form";
import {
setChatBotMessageValue,
addMessage,
addBotMessage,
setInputDisable,
disableDatePicker,
setUserInfos,
setSelectedDay,
setSelectedTime,
sendPlanDemand,
updateUser,
updateFirstname,
updateLastname,
updateAdress,
updateCity,
updateZIPCode,
updatePhoneNumber,
loadingBotMessage,
clearChatBot
} from "../../../../actions/PlanDemand";

const MapStateToProps = (state) => ({
messageValue: state.planDemand.messageValue,
inputDisabled: state.planDemand.inputDisabled,
userInfos: state.planDemand.userInfos,
selectedDay: state.planDemand.selectedDay,
selectedTime: state.planDemand.selectedTime,
tel: state.planDemand.userInfos.tel,
dataUser: state.user.dataUser,
});

const MapDispatchToProps = (dispatch) => ({
setChatBotMessageValue: (value) => {
dispatch(setChatBotMessageValue(value));
},
addMessage: (message) => {
dispatch(addMessage(message));
},
addBotMessage: (message, messageType) => {
dispatch(addBotMessage(message, messageType));
},
setInputDisable: (bool) => {
dispatch(setInputDisable(bool));
},
disableDatePicker: (bool) => {
dispatch(disableDatePicker(bool));
},
setUserInfos: (value, type) => {
dispatch(setUserInfos(value, type));
},
setSelectedDay: (day) => {
dispatch(setSelectedDay(day));
},
setSelectedTime: (time) => {
dispatch(setSelectedTime(time));
},
sendPlanDemand: () => {
dispatch(sendPlanDemand());
},
updateUser: (value) => {
dispatch(updateUser(value));
},
updateFirstname: () => {
dispatch(updateFirstname());
},
updateLastname: () => {
dispatch(updateLastname());
},
updateAdress: () => {
dispatch(updateAdress());
},
updateCity: () => {
dispatch(updateCity());
},
updateZIPCode: () => {
dispatch(updateZIPCode());
},
updatePhoneNumber: () => {
dispatch(updatePhoneNumber());
},
loadingBotMessage: (bool) => {
dispatch(loadingBotMessage(bool));
},
clearChatBot: () => {
dispatch(clearChatBot());
},
});

export default connect(MapStateToProps, MapDispatchToProps)(Form);